var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.438 9.287h.379c.379 0 .694-.339.694-.747 0-.508-.181-.607-.478-.712l-.59-.204v1.663h-.005z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.982 1.108A5.835 5.835 0 0 0 1.166 6.96a5.836 5.836 0 0 0 5.85 5.816 5.836 5.836 0 0 0 5.817-5.85 5.84 5.84 0 0 0-5.851-5.817zM8.318 7c.455.158 1.067.496 1.067 1.54 0 .898-.706 1.622-1.569 1.622h-.38v.338a.44.44 0 0 1-.437.438.44.44 0 0 1-.437-.438v-.338h-.21c-.957 0-1.733-.805-1.733-1.797a.44.44 0 0 1 .438-.437.44.44 0 0 1 .437.437c0 .508.385.922.858.922h.21V7.315L5.68 7c-.455-.157-1.067-.496-1.067-1.54 0-.898.705-1.622 1.569-1.622h.379V3.5a.44.44 0 0 1 .437-.437.44.44 0 0 1 .438.437v.338h.21c.957 0 1.732.805 1.732 1.797a.44.44 0 0 1-.437.438.44.44 0 0 1-.438-.438c0-.507-.385-.922-.857-.922h-.21v1.972l.88.315z",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.494 5.466c0 .507.181.607.478.712l.59.204V4.713h-.38c-.379 0-.688.339-.688.753z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDollar);
export default __webpack_public_path__ + "static/media/ic_dollar.6c38780c8c2c102ef27a943e5f8984b9.svg";
export { ForwardRef as ReactComponent };